module["exports"] = [
  "#{street_root}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_au_ocker/address/street_name.js
// module id = 1157
// module chunks = 0